import { createFileRoute } from '@tanstack/react-router';
import { Field } from '@osd/ui/field';
import { Select } from '@osd/ui/select';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/select — live docs for the `Select` primitive.
 */
export const Route = createFileRoute('/ui/_layout/select')({
  component: SelectPage,
});

function SelectPage() {
  return (
    <Stack gap={6}>
      <Section title="Select" hint="native <select> with CSS-painted caret (no JS dependency)">
        <Stack gap={3}>
          <Field label="Country">
            <Select name="country" defaultValue="us">
              <option value="us">United States</option>
              <option value="uk">United Kingdom</option>
              <option value="de">Germany</option>
              <option value="jp">Japan</option>
            </Select>
          </Field>
          <Field label="Role">
            <Select name="role">
              <option value="viewer">Viewer</option>
              <option value="editor">Editor</option>
              <option value="admin">Admin</option>
            </Select>
          </Field>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Basic — uncontrolled with options"
            language="tsx"
            code={`<Field label="Country">
  <Select name="country" defaultValue="us">
    <option value="us">United States</option>
    <option value="uk">United Kingdom</option>
    <option value="de">Germany</option>
  </Select>
</Field>`}
          />

          <CodeBlock
            title="Controlled"
            language="tsx"
            code={`const [role, setRole] = useState('viewer');
return (
  <Field label="Role">
    <Select
      name="role"
      value={role}
      onChange={(e) => setRole(e.target.value)}
    >
      <option value="viewer">Viewer</option>
      <option value="editor">Editor</option>
      <option value="admin">Admin</option>
    </Select>
  </Field>
);`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
